export default __webpack_public_path__ + "static/webRotator/svg/a3804ee97f435e6125013714b50d7e16.svg";